// NAP (Name, Address, Phone) ufficiale: DEVE coincidere carattere per carattere
// con la scheda Google Business Profile. Usato da Home, Footer, Contatti.
// Fonte: scheda Google "Polverini Hair System Di Leone Itria" (22 ott 2026).
export const NAP = {
  name: "Polverini Hair System di Leone Itria", // nome esatto della scheda Google Business Profile
  displayName: "Polverini Hair System",
  byLine: "by Itria Leone",
  city: "Palazzolo Acreide",
  address: "Via Bando Superiore, 49, 96010 Palazzolo Acreide SR",
  landline: "0931 453982",
  mobile: "338 323 6550", // DA CONFERMARE con il cliente (fonte: vecchio sito + Pagine Bianche)
  landlineHref: "tel:+390931453982",
  mobileHref: "tel:+393383236550",
  whatsapp: "393383236550",
  mapsUrl: "https://www.google.com/maps?cid=9947438244455690229",
  hours: [
    { days: "Mar - Ven", time: "09:00 - 13:00 / 15:00 - 19:00" },
    { days: "Sabato", time: "08:00 - 19:00" },
    { days: "Domenica e lunedì", time: "chiuso" },
  ],
  hoursShort: "Mar-Ven 9-13 / 15-19 · Sab 8-19",
};

/**
 * Normalizza un numero visualizzato (es. "338 323 6550", "+39 0931 453982")
 * nel formato E.164 italiano per gli href tel:/wa.me → "+393383236550".
 */
export function toE164(display) {
  const digits = String(display || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("39") && digits.length >= 11) return `+${digits}`;
  return `+39${digits}`;
}

/** Rimuove il prefisso internazionale per la visualizzazione (formato scheda Google). */
export function toDisplay(value, fallback) {
  const v = String(value || "").trim();
  if (!v) return fallback;
  return v.replace(/^\+39\s?/, "");
}
